
const initSingleNumBet = () => {
  const keyObj = {}

  for (let i = 1; i <= 6; i++) {
    const groupKey = `${i}:MATCH:ALL`
    keyObj[groupKey] = {
      mainKey: 'single_num_bet',
      supKey: '',
      groupKey
    }
  }

  return keyObj
}

const initSumOfValue = () => {
  const mainKey = 'sum_of_value'
  const overUnderKey = groupKey => {
    return {
      mainKey,
      supKey: 'two_side',
      groupKey
    }
  }
  const keyObj = {
    'ALL:SUM:OVER': overUnderKey('ALL:SUM:OVER'),
    'ALL:SUM:UNDER': overUnderKey('ALL:SUM:UNDER'),
    'ALL:SUM:ODD': overUnderKey('ALL:SUM:ODD'),
    'ALL:SUM:EVEN': overUnderKey('ALL:SUM:EVEN')
  }

  for (let i = 4; i <= 17; i++) {
    const groupKey = `ALL:SUM:${i}`
    keyObj[groupKey] = {
      mainKey,
      supKey: 'sum_of_value',
      groupKey
    }
  }

  return keyObj
}

const initTwoPairMatchThree = () => {
  const mainKey = 'two_pair_match_three'

  const keyObj = {
    'ANY:TRIPLE': {
      mainKey,
      supKey: 'full_dice',
      groupKey: 'ANY:TRIPLE'
    }
  }

  for (let i = 1; i <= 6; i++) {
    keyObj[`${i}:${i}:COMBI`] = {
      mainKey,
      supKey: 'two_pair_match_three',
      groupKey: `${i}:${i}:COMBI`
    }
    keyObj[`${i}:TRIPLE`] = {
      mainKey,
      supKey: 'triple_dice',
      groupKey: `${i}:TRIPLE`
    }
  }

  return keyObj
}

const initTwoDiffMatchThree = () => {
  const keyObj = {}

  for (let i = 1; i <= 6; i++) {
    for (let j = i + 1; j <= 6; j++) {
      const groupKey = `${i}:${j}:COMBI`
      keyObj[`${i}:${j}:COMBI`] = {
        mainKey: 'two_diff_match_three',
        supKey: '',
        groupKey
      }
    }
  }

  return keyObj
}

export default {
  ...initSingleNumBet(),
  ...initSumOfValue(),
  ...initTwoPairMatchThree(),
  ...initTwoDiffMatchThree()
}
